import React from 'react';
import { Select, Input } from 'antd';

/**
 * Champ générique pour une ressource Meta (compte publicitaire, Page, pixel, catalogue).
 *
 * Affiche une liste déroulante quand les ressources ont pu être récupérées depuis Meta,
 * et un champ de saisie libre sinon (permission manquante, compte non encore sélectionné).
 * Utilisé aussi bien dans l'écran de configuration que dans le formulaire de campagne,
 * afin de ne pas dupliquer cette logique.
 *
 * @param {Array}    options     - Options { value, label } issues des ressources Meta
 * @param {string}   placeholder - Texte d'aide du champ
 * @param {string}   value       - Valeur courante (fournie par Form.Item)
 * @param {Function} onChange    - Callback de modification (fourni par Form.Item)
 */
const ChampRessource = ({ options = [], placeholder, value, onChange }) => {
  if (options.length === 0) {
    return (
      <Input
        placeholder={placeholder}
        value={value}
        onChange={e => onChange?.(e.target.value)}
      />
    );
  }

  return (
    <Select
      showSearch
      allowClear
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      optionFilterProp="label"
      options={options}
    />
  );
};

export default ChampRessource;
